import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {
  GblMenuModel,
  GblMenuobject,
  GeneralResModel,
  MenuResModel,
} from "src/app/_models";
import { CommonResponse } from "src/app/_models/common-response.modle";
import { GblJobtypemenuepermision } from "src/app/_models/Menu/gbl-jobtypemenu-pemission.model";
import { JobtypeMenuobjectPermission } from "src/app/_models/Menu/jobtype-menuobject-permission.model";
import { MenuobjectQuery } from "src/app/_models/Menu/menuobject-query.model";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class AppMenuService {
  private apiPath = "Menu/";

    private currentMenuIdSubject = new BehaviorSubject<number | null>(null);

    // Observable stream to subscribe to
    currentMenuId$ = this.currentMenuIdSubject.asObservable();

    constructor(private _api: ApiService) {}

    // Setter to update the current menu ID
    setCurrentMenuId(menuId: number | null): void {
        this.currentMenuIdSubject.next(menuId);
    }

    // Getter for the current value (optional)
    getCurrentMenuId(): number | null {
        return this.currentMenuIdSubject.value;
    }
  getGblMenus() {
    return this._api.get<GeneralResModel<GblMenuModel[]>>(
      `${this.apiPath}GetGblMenus`
    );
  }

  createMenu(request: GblMenuModel) {
    return this._api.post<GeneralResModel<GblMenuModel>>(
      `${this.apiPath}CreateMenu`,
      request
    );
  }

  updateMenu(request: GblMenuModel) {
    return this._api.post<GeneralResModel<GblMenuModel>>(
      `${this.apiPath}UpdateMenu`,
      request
    );
  }

  deleteMenu(request: GblMenuModel) {
    return this._api.post<GeneralResModel<GblMenuModel>>(
      `${this.apiPath}DeleteMenu`,
      request
    );
  }

  getMenuList(empId: number) {
    return this._api.get<GeneralResModel<MenuResModel[]>>(
      `${this.apiPath}GetMenuList/${empId}`
    );
  }
  getJobtypemenuepermisions(orgId: number) {
    return this._api.get<GeneralResModel<GblJobtypemenuepermision[]>>(
      `${this.apiPath}GetJobtypemenuepermisions/${orgId}`
    );
  }
  getJobtypemenuepermisionById(permissionmenuId: number) {
    return this._api.get<GeneralResModel<GblJobtypemenuepermision>>(
      `${this.apiPath}GetJobtypemenuepermisionById/${permissionmenuId}`
    );
  }
  getGblJobtypemenuepermision(
    jobtypeId: number,
    menuId: number,
    orgId: number
  ) {
    return this._api.get<GeneralResModel<GblJobtypemenuepermision>>(
      `${this.apiPath}GetGblJobtypemenuepermision/${jobtypeId}/${menuId}/${orgId}`
    );
  }

  createJobtypemenuepermision(request: GblJobtypemenuepermision) {
    return this._api.post<GeneralResModel<GblJobtypemenuepermision>>(
      `${this.apiPath}CreateJobtypemenuepermision`,
      request
    );
  }

  updateJobtypemenuepermision(request: GblJobtypemenuepermision) {
    return this._api.post<GeneralResModel<GblJobtypemenuepermision>>(
      `${this.apiPath}UpdateJobtypemenuepermision`,
      request
    );
  }

  deleteJobtypemenuepermision(request: GblJobtypemenuepermision) {
    return this._api.post<GeneralResModel<GblJobtypemenuepermision>>(
      `${this.apiPath}DeleteJobtypemenuepermision`,
      request
    );
  }

  getActiveGblMenus() {
    return this._api.get<GeneralResModel<GblMenuModel[]>>(
      `${this.apiPath}GetActiveGblMenus`
    );
  }

  getJobtypemenuobjectpermision(request: MenuobjectQuery) {
    return this._api.post<GeneralResModel<JobtypeMenuobjectPermission[]>>(
      `${this.apiPath}GetJobtypemenuobjectpermision`,
      request
    );
  }

  getGblMenuobjectByMenu(menuId: number) {
    return this._api.get<GeneralResModel<GblMenuobject[]>>(
      `${this.apiPath}GetGblMenuobjectByMenu/${menuId}`
    );
  }

  addMenuobject(body: GblMenuobject) {
    return this._api.post<CommonResponse>(`${this.apiPath}AddMenuobject`, body);
  }

  updateMenuobject(body: GblMenuobject) {
    return this._api.post<CommonResponse>(
      `${this.apiPath}UpdateMenuobject`,
      body
    );
  }

  GetNextSlMenuobject(menuId: number) {
    return this._api.get<any>(`${this.apiPath}GetNextSlMenuobject/${menuId}`);
  }
}
